import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  title = 'igreja-view';

  ngOnInit(): void {
    const spinner = document.querySelector('.spinner');
    if (spinner) {
      spinner.remove();
    }
  }


}
